<tec-spinner [show]="sending"></tec-spinner>


<tec-auth-layout
        img="assets/img/resources/tecalis.svg"
        imgTitle="Tecalis Sign"
        title="{{ 'AUDIT.CODE.TITLE' | translate }}"
        subTitle="Introduce tu código de validación y obtén de inmediato tu informe personalizado de auditoría"
>
    <ng-container body>
        <img src="assets/img/resources/password.svg" alt="">
        <!--<form [formGroup]="form">-->
        <tec-form-group
            [formGroup]="form"
        >
            <tec-input
                    id="vc-code"
                    [placeholder]="'Código de validación'"
                    [type]="'text'"
                    [maxlength]="22"
                    [formControlName]="'code'"
                    [disabled]="sending"
                    (input)="inputCode($event)"
            ></tec-input>
        </tec-form-group>
            <tec-alert
                    *ngIf="error"
                    [status]="'error'"
                    [msg]="(error | translate)"
                    (closeAlert)="error = ''"
            ></tec-alert>
           <tec-button
                    size="lg"
                    [label]="'Accede al informe'"
                    [type]="'default'"
                    [disabled]="!form.valid || sending"
                    (clickEvent)="checkCode()"
            ></tec-button>

        <!--</form>-->

    </ng-container>
</tec-auth-layout>
